import {
  _initializeUniversalComponent,
  withContext,
} from './universalComponent';
import utils from './utils';

window.addEventListener('DOMContentLoaded', () => {
  _initializeUniversalComponent();

  const onLoadEvent = new CustomEvent('onAppExtensionSDKLoaded');
  window.dispatchEvent(onLoadEvent);
});

window.shopline = Object.assign(window.shopline || {}, {
  appExtension: {
    universalComponent: {
      withContext,
    },
    utils,
  },
});
